import React, { useEffect, useState } from "react"
import { Modal, Spin, Descriptions, message } from "antd"
import PackageService from "src/services/PackageService"
import STORAGE, { getStorage } from "src/lib/storage"

const PackageDetail = ({ id }) => {
  const [loading, setLoading] = useState(false)
  const [packageData, setPackageData] = useState(null)
  const role = localStorage.getItem(STORAGE.ROLES)

  useEffect(() => {
    if (id) {
      fetchPackageDetail(id)
    }
  }, [id])

  const fetchPackageDetail = async packageId => {
    setLoading(true)
    try {
      if (role === "ADMIN") {
        const response = await PackageService.packageDetail(packageId)

        setPackageData(response.success)
      }
      if (role === "LEADER") {
        const response = await PackageService.packageDetailLeader(packageId)
        setPackageData(response.success)
      }
    } catch (error) {
      message.error("Không thể lấy thông tin gói cước")
    } finally {
      setLoading(false)
    }
  }

  if (loading) return <Spin />

  if (!packageData) return <></>

  return (
    <Descriptions title="Thông tin gói cước" bordered column={1} size="small">
      <Descriptions.Item label="Tên gói">{packageData.name}</Descriptions.Item>
      <Descriptions.Item label="Dung lượng">
        {packageData.data_quantity} GB
      </Descriptions.Item>
      <Descriptions.Item label="Giá bán">
        {Number(packageData.price_sell).toLocaleString()} VNĐ
      </Descriptions.Item>
    </Descriptions>
  )
}

export default PackageDetail
